import React from 'react';
import DealerAd from '../..';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import cn from 'classnames';
import s from './Banner.scss';
const BannerAdUnit = ({ realEstateId, width, height, className })=>{
    const isMounted = useIsMounted();
    if (!isMounted) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "BannerAdUnit"
    }, /*#__PURE__*/ React.createElement("div", {
        className: cn(s['wrapper'], className),
        style: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement(DealerAd, {
        realEstateId: realEstateId,
        extraParams: process.env.NODE_ENV === 'development' ? {
            forcefixture: `complexbanner${width}-${height}`
        } : {}
    })));
};
BannerAdUnit.displayName = 'BannerAdUnit';
export default BannerAdUnit;
